// extracted by mini-css-extract-plugin
export default {"titleContainer":"Title_titleContainer__QQBRr","title":"Title_title__gFMHO","nameField":"Title_nameField__Zrqvu"};